export default __webpack_public_path__ + "aae41ea25bd0dde9f796bf3b6a1ff27f.ttf";